import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beach',
  templateUrl: './beach.component.html',
  styleUrls: ['./beach.component.scss']
})
export class BeachComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
